import { useState, useEffect } from 'react';
import { Slider } from '../../shared/components/layout/Slider/Slider';
import { Styled } from './Styled';
import { Banner } from '../../shared/components/layout/banner/Banner';
import { MiniCard } from '../../shared/components/layout/miniCard/MiniCard';
import { IListTrainingAreas, TrainingAreaServices } from '../../shared/Services/api/trainingArea/TrainingArea.services';
import { Header } from '../../shared/components/layout/header/Header';
import { Footer } from '../../shared/components/layout/footer/Footer';
import { BannerServices, IBanner } from '../../shared/Services/api/banners/Banners.services';
import { TestimonyServices, ITestimony } from '../../shared/Services/api/testimony/Testimony.services';
import { Testymony } from '../../shared/components/layout/testymony/testymony';

export const Home = () => {
    const [currentTestymonyIndex, setCurrentTestymonyIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [AllTrainingAreas, setAllTrainingAreas] = useState<IListTrainingAreas | null>(null);
    const [banners, setBanners] = useState<IBanner[]>([]);
    const [testimonies, setTestimonies] = useState<ITestimony[]>([]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (testimonies.length > 0 && !isPaused) {
            const interval = setInterval(() => {
                setCurrentTestymonyIndex((prevIndex) => {
                    const itemsVisible = windowWidth <= 768 ? 1 : 2; // Corrigido para 2
                    const maxIndex = Math.max(0, testimonies.length - itemsVisible);
                    
                    if (prevIndex >= maxIndex) {
                        return 0; // Volta para o começo
                    }
                    return prevIndex + 1;
                });
            }, 4000);

            return () => clearInterval(interval);
        }
    }, [windowWidth, testimonies, isPaused]);

    //get all training areas
    useEffect(() => {
        const fetchTrainingAreas = async () => {
            try {
                const response = await TrainingAreaServices.getAllTrainingAreas();
                if (!(response instanceof Error)) {
                    setAllTrainingAreas(response);
                } else {
                    console.error('Erro ao buscar áreas de treinamento:', response);
                }
            } catch (error) {
                console.error('Erro ao buscar áreas de treinamento:', error);
            }
        };
        fetchTrainingAreas();
    }, []);

    //get all banners
    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const response = await BannerServices.getAllBanners();
                if (!(response instanceof Error)) {
                    setBanners(response.data);
                } else {
                    console.error('Erro ao buscar banners:', response);
                }
            } catch (error) {
                console.error('Erro ao buscar banners:', error);
            }
        };
        fetchBanners();
    }, []);

    //get all testimonies
    useEffect(() => {
        const fetchTestimonies = async () => {
            try {
                const response = await TestimonyServices.getAllTestimonies();
                if (!(response instanceof Error)) {
                    setTestimonies(response.data);
                } else {
                    console.error('Erro ao buscar depoimentos:', response);
                }
            } catch (error) {
                console.error('Erro ao buscar depoimentos:', error);
            }
        };
        fetchTestimonies();
    }, []);

    const calculateTranslateX = () => {
        // No desktop, cada item ocupa 49% + 1% de gap = 50%
        const step = windowWidth <= 768 ? 100 : 50;
        return `translateX(-${currentTestymonyIndex * step}%)`;
    };

    return (
        <Styled.Content>
            <Header />
            <div className="BannerArea">
                {banners && banners.length > 0 && (
                    <Slider>
                        {banners.map((banner) => (
                            <Banner
                                key={banner._id}
                                srcDeskImg={banner.DeskPictureUrl || ''}
                                srcMobileImg={banner.MobilePictureUrl || ''}
                                name={banner.Name}
                            />
                        ))}
                    </Slider>
                )}
            </div>
            <div className="TrainingAreasArea">
                <div className="DivisorTittle2">
                    <h1>Áreas de Formações</h1>
                    <div className="Underline"></div>
                    <p style={{ marginTop: '20px', color: '#666', fontFamily: 'var(--first-font)', textAlign: 'center' }}>
                        Explore nossas diversas áreas e escolha o caminho que mais combina com seus objetivos profissionais.
                    </p>
                </div>
                <div className="MiniCardArea">
                    {AllTrainingAreas?.data.map((trainingArea) => (
                        <MiniCard key={trainingArea._id} trainingAreaId={trainingArea._id} />
                    ))}
                </div>
            </div>

            {testimonies.length > 0 && (
                <div className="TestymonyArea">
                    <div className="TestymonyHeader">
                        <h2>O que nossos alunos dizem</h2>
                        <p>Confira as experiências de quem já transformou sua carreira com a NewZape.</p>
                    </div>
                    
                    <div className="TestymonyWrapper">
                        <div 
                            className="TestymonyContainer"
                            style={{ transform: calculateTranslateX() }}
                            onMouseEnter={() => setIsPaused(true)}
                            onMouseLeave={() => setIsPaused(false)}
                        >
                            {testimonies.map((testimony) => (
                                <Testymony 
                                    key={testimony._id}
                                    name={testimony.ClientName}
                                    text={testimony.TestimonyText}
                                    pictureUrl={testimony.PictureUrl}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </Styled.Content>
    )
}